import {
  ActionIcon,
  Button,
  Card,
  Group,
  ScrollArea,
  Table,
  Text,
  TextInput,
} from '@mantine/core';
import { IoMdSearch } from 'react-icons/io';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import { useClientIPPFormContext } from '../ClientIppSection';
import { type Employees } from '@/schemas/API/GET/employee/response';

export const WorkerModal = ({
  closeModal,
  startId,
}: {
  closeModal: () => void;
  startId: number | null;
}): JSX.Element => {
  const form = useClientIPPFormContext();

  const [searchValue, setSearchValue] = useState('');
  const [query, setQuery] = useState<string>('');

  const [changed, setChanged] = useState(false);

  const [workerId, setWorkerId] = useState(startId);
  const [workerFirstName, setWorkerFirstName] = useState('');
  const [workerLastName, setWorkerLastName] = useState('');
  const [workerRole, setWorkerRole] = useState('');

  const { data: workers } = useSWR<Employees>(
    `employees?query=${query}`,
    getFetcher
  );


  const rows = workers?.content.map(element => (
    <Table.Tr key={element.id}>
      <Table.Td>
        <ActionIcon variant="transparent" color="darkblue" size="lg">
          <FaCalendarAlt />
        </ActionIcon>
      </Table.Td>
      <Table.Td>{element.firstName + ' ' + element.lastName}</Table.Td>
      <Table.Td>{element.access?.role}</Table.Td>
      <Table.Td align="right">
        <Button
          variant={element.id === workerId ? 'filled' : 'outline'}
          radius="md"
          onClick={() => {
            setChanged(true);
            setWorkerId(element.id);
            setWorkerFirstName(element.firstName);
            setWorkerLastName(element.lastName);
            setWorkerRole(element.access?.role);
          }}
        >
          {element.id === workerId ? 'Vybráno' : ' Vybrat '}
        </Button>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Card>
      <Text fw={700} size="lg">
        Vybrat klíčového pracovníka
      </Text>
      <TextInput
        size="md"
        mt="sm"
        mb="sm"
        placeholder="search"
        value={searchValue}
        onChange={event => setSearchValue(event.currentTarget.value)}
        onKeyDown={event => {
          event.key === 'Enter' && setQuery(searchValue);
        }}
        leftSection={
          <ActionIcon
            variant="transparent"
            color="gray"
            onClick={() => {
              setQuery(searchValue);
            }}
          >
            <IoMdSearch />
          </ActionIcon>
        }
      />
      <ScrollArea h={500}>
        <Table>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </ScrollArea>
      <Group justify="space-between" mt="lg">
        <Button
          variant="outline"
          radius="md"
          pl="xl"
          pr="xl"
          onClick={() => {
            closeModal();
          }}
        >
          Zrušit
        </Button>
        <Button
          variant="filled"
          radius="md"
          pl="xl"
          pr="xl"
          onClick={() => {
            closeModal();
            changed &&
              form.setFieldValue('keyEmp', {
                id: workerId ?? 0,
                firstName: workerFirstName,
                lastName: workerLastName,
                access: { serviceId: 0, role: workerRole },
              });
          }}
        >
          Potvrdit
        </Button>
      </Group>
    </Card>
  );
};
